'use client';

import { useEffect } from 'react';

// Loads the Adobe TypeKit/Adobe Fonts stylesheet asynchronously after mount.
export default function TypeKitFontLoader() {
  useEffect(() => {
    const linkId = 'typekit-font-loader-stylesheet';
    if (document.getElementById(linkId)) {
      return;
    }
    const link = document.createElement('link');
    link.id = linkId;
    link.rel = 'stylesheet';
    link.href = 'https://use.typekit.net/dew0hus.css';
    document.head.appendChild(link);
  }, []);

  return null;
}
